import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FakeText, Typography } from '@totalsoft/rocket-ui';
import { Accordion, AccordionDetails, AccordionSummary, Grid, Tooltip, IconButton } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import QuestionActionComponent from './QuestionActionListItemComponent';
import QuestionActionSummaryComponent from './QuestionActionSummaryComponent';
import { Delete, Save } from '@mui/icons-material';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';

const QuestionActionListComponent = ({
  questionActions,
  questionActionTypes,
  loading,
  onSave,
  onDelete,
  validation,
  isReadOnly,
  onPropertyChanged,
  onExpandedChanged,
  getIndexInFilteredList
}) => {
  const { t } = useTranslation();
  questionActions.forEach(element => { element.questionActionTypes = questionActionTypes.find(item => item.id === element.questionActionTypeId)});  
  return questionActions.map((item, idx) => {
    const header = <QuestionActionSummaryComponent questionActions={item} />;
    const index = getIndexInFilteredList(idx);

    return (
      <Grid key={idx} item xs={12} sx={{ marginBottom: '35px!important' }}>
        <Accordion expanded={item.isExpanded} onChange={(_, isExpanded) => onExpandedChanged(index, isExpanded)}>
          <AccordionSummary sx={{ width: '100%' }} expandIcon={<ExpandMoreIcon />}>
            {(item.isExpanded || (!item.isExpanded && !header)) && (
              <Grid container spacing={1} justifyContent='flex-end' onClick={event => event.stopPropagation()}>
                <Grid item>
                  <Tooltip title={t('Questionnaire.SaveChanges')}>
                    <div>
                      <IconButton
                        color='primary'
                        onClick={onSave(index)}
                        disabled={isReadOnly || !item.changed || !(validation[index] |> isValid) || (validation |> getErrors) !== ''}
                      >
                        <Save />
                      </IconButton>
                    </div>
                  </Tooltip>
                </Grid>
                <Grid item>
                  <Tooltip title={t('Tooltips.Questionnaire.DeleteQuestionAction')}>
                    <IconButton color='primary' onClick={onDelete(index)} disabled={isReadOnly}>
                      <Delete />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
            )}
            {!item.isExpanded && header}
          </AccordionSummary>
          <AccordionDetails>
            {loading ? (
              <FakeText lines={10} />
            ) : (
              <Grid container spacing={1}>
                <Grid container item xs={12} justifyContent='flex-end'>
                  <Typography color='error'>{validation |> getErrors}</Typography>
                </Grid>
                <QuestionActionComponent
                  questionAction={item}
                  index={index}
                  questionActionTypes={questionActionTypes}
                  loading={loading}
                  onSave={onSave}
                  collectionValidation={validation}
                  isReadOnly={isReadOnly}
                  onPropertyChanged={onPropertyChanged}
                />
              </Grid>
            )}
          </AccordionDetails>
        </Accordion>
      </Grid>
    );
  });
};

QuestionActionListComponent.propTypes = {
  questionActions: PropTypes.array.isRequired,
  questionActionTypes: PropTypes.array,
  loading: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired,
  isReadOnly: PropTypes.bool,
  onPropertyChanged: PropTypes.func.isRequired,
  onExpandedChanged: PropTypes.func.isRequired,
  getIndexInFilteredList: PropTypes.func.isRequired
};

export default QuestionActionListComponent;
